function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["buttonLook", "className", "label", "labelPosition", "labelProps", "look", "showLabel", "size", "svgCircleProps", "svgProps"],
  _excluded2 = ["look"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import { LoaderLabelPositions, LoaderSizes, LoaderLooks } from "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import { fontFamilyBook } from "../../../../themes/fonts.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import { getLoaderPosition, getLoaderSize, getLoaderTheme, getLoaderRotate, getLoaderStroke, getLoaderStretch } from "../../../../styles/styled-components/loader.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import { BaseLoader } from "../base-loader/base-loader.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BaseCircleLoader = function BaseCircleLoader(props) {
  var _classnames;
  var buttonLook = props.buttonLook,
    className = props.className,
    label = props.label,
    _props$labelPosition = props.labelPosition,
    labelPosition = _props$labelPosition === void 0 ? LoaderLabelPositions.Right : _props$labelPosition,
    labelProps = props.labelProps,
    look = props.look,
    _props$showLabel = props.showLabel,
    showLabel = _props$showLabel === void 0 ? false : _props$showLabel,
    _props$size = props.size,
    size = _props$size === void 0 ? LoaderSizes.Medium : _props$size,
    svgCircleProps = props.svgCircleProps,
    svgProps = props.svgProps,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(BaseLoader, _extends({}, otherProps, {
    "aria-label": showLabel ? undefined : label,
    "aria-hidden": buttonLook && !label ? true : undefined,
    className: classnames((_classnames = {
      'bf-loader__circle': true
    }, _defineProperty(_classnames, "bf-loader__circle--label-".concat(labelPosition), labelPosition), _defineProperty(_classnames, "bf-loader__circle--look-".concat(look), look), _defineProperty(_classnames, "bf-loader__circle--size-".concat(size), size), _defineProperty(_classnames, "".concat(className), !!className), _classnames))
  }), /*#__PURE__*/React.createElement("svg", _extends({}, svgProps, {
    "aria-hidden": true,
    className: classnames(_defineProperty({
      'bf-loader__svg': true
    }, "".concat(svgProps === null || svgProps === void 0 ? void 0 : svgProps.className), !!(svgProps !== null && svgProps !== void 0 && svgProps.className))),
    viewBox: "25 25 50 50",
    role: "img"
  }), /*#__PURE__*/React.createElement("circle", _extends({}, svgCircleProps, {
    className: classnames(_defineProperty({
      'bf-loader__svg-circle': true
    }, "".concat(svgCircleProps === null || svgCircleProps === void 0 ? void 0 : svgCircleProps.className), !!(svgCircleProps !== null && svgCircleProps !== void 0 && svgCircleProps.className))),
    cx: "50",
    cy: "50",
    r: "20"
  }))), showLabel && /*#__PURE__*/React.createElement("span", _extends({}, labelProps, {
    className: classnames(_defineProperty({
      'bf-loader__label': true
    }, "".concat(labelProps === null || labelProps === void 0 ? void 0 : labelProps.className), !!(labelProps !== null && labelProps !== void 0 && labelProps.className)))
  }), label));
};
var Loader = styled(BaseCircleLoader)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  align-items: center;\n  box-sizing: border-box;\n  display: inline-flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  overflow: hidden;\n  width: 100%;\n\n  .bf-loader__label {\n    font-family: ", ";\n    max-width: 300px;\n  }\n\n  .bf-loader__svg {\n    animation: ", " 2s linear infinite;\n    flex-shrink: 0;\n    transform-origin: center;\n  }\n\n  .bf-loader__svg-circle {\n    fill: transparent;\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n    stroke-linecap: round;\n    stroke-width: 5px;\n    animation:\n      ", " 3s cubic-bezier(1, 0, 0, 1) infinite,\n      ", " 1.5s ease-in-out infinite;\n  }\n"])), function (_ref) {
  var labelPosition = _ref.labelPosition,
    size = _ref.size;
  return getLoaderPosition({
    labelPosition: labelPosition,
    size: size
  });
}, function (_ref2) {
  var size = _ref2.size;
  return getLoaderSize({
    size: size
  });
}, function (_ref3) {
  var buttonLook = _ref3.buttonLook,
    look = _ref3.look;
  return getLoaderTheme({
    buttonLook: buttonLook,
    look: look
  });
}, fontFamilyBook, getLoaderRotate(), function (_ref4) {
  var look = _ref4.look,
    theme = _ref4.theme;
  return getLoaderStroke({
    look: look,
    theme: theme
  });
}, getLoaderStretch());
var CircleLoader = function CircleLoader(props) {
  var _props$look = props.look,
    look = _props$look === void 0 ? LoaderLooks.Primary : _props$look,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Loader, _extends({
    look: look
  }, otherProps)));
};
export { CircleLoader };